import {
  Assignment,
  Menu,
  Person,
  History,
  Inventory,
  CurrencyExchange,
  Settings,
  Sync,
  AccountBalance,
  Drafts,
  Send,
  Contacts,
  CalendarMonth,
  Logout,
  AccountCircle,
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { syncDatabase } from "../utils/offlineSync";
import { useAuth0 } from "@auth0/auth0-react";

function TopNav({ pageTitle }: { pageTitle?: string }) {
  const nav = useNavigate();
  const { logout } = useAuth0();
  const [drawerOpen, toggleDrawerOpen] = useState(false);
  const token = localStorage.getItem("token");
  if (token === null) {
    nav("/login");
    return <></>;
  }

  const doSync = () => {
    syncDatabase(token).then(() => {
      window.location.reload();
    });
  };

  const signOut = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      await syncDatabase(token);
    }
    localStorage.removeItem("token");
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}/login`,
      },
    });
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => toggleDrawerOpen(!drawerOpen)}
          >
            <Menu />
          </IconButton>
          <Box sx={{ flexGrow: 1 }}>
            <Typography align="center">{pageTitle}</Typography>
          </Box>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="sync"
            sx={{ mr: 2 }}
            onClick={doSync}
          >
            <Sync />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer open={drawerOpen} onClose={() => toggleDrawerOpen(false)}>
        <List sx={{ minWidth: 300 }}>
          <ListItemButton
            component={Link}
            to="/customers"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary="Customers" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/proposals"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Assignment />
            </ListItemIcon>
            <ListItemText primary="Proposals" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/appointments"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <CalendarMonth />
            </ListItemIcon>
            <ListItemText primary="Appointments" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/activity"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <History />
            </ListItemIcon>
            <ListItemText primary="Activity" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/products"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Inventory />
            </ListItemIcon>
            <ListItemText primary="Products" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/emails"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Send />
            </ListItemIcon>
            <ListItemText primary="Emails" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/email-templates"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Drafts />
            </ListItemIcon>
            <ListItemText primary="Email Templates" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/taxes"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <CurrencyExchange />
            </ListItemIcon>
            <ListItemText primary="Taxes" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/contact-form"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Contacts />
            </ListItemIcon>
            <ListItemText primary="Contact Form" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/settings"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/quickbooks"
            onClick={() => toggleDrawerOpen(false)}
          >
            <ListItemIcon>
              <AccountBalance />
            </ListItemIcon>
            <ListItemText primary="Quickbooks" />
          </ListItemButton>
        </List>
        <Divider />
        <List>
          <ListItem>
            <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>
            <ListItemText primary={localStorage.getItem("username")} />
          </ListItem>
          <ListItemButton onClick={() => signOut()}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
          </ListItemButton>
        </List>
      </Drawer>
    </>
  );
}

export default TopNav;
